<template>
  <canvas
    :id="id"
    ref="barCanvas"
    style="height: 100%; width: 100%"
    :style="styleBarChart"
  ></canvas>
</template>

<script lang="ts">
import {
  Chart,
  ChartOptions,
  BarController,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title,
  ChartData
} from 'chart.js';

import type { ComponentPublicInstance, PropType, StyleValue } from 'vue';

Chart.register(
  BarController,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title
);

/* eslint-disable */

export default {
  name: 'BarChart',
  props: {
    id: { type: String, required: true },
    dataBarChart: {
      type: Object as PropType<ChartData<'bar'>>,
      required: true
    },
    optionsBarChart: {
      type: Object as PropType<ChartOptions<'bar'>>,
      default: () => ({})
    },
    styleBarChart: {
      type: [Object, String] as PropType<StyleValue>,
      default: () => ({})
    }
  },
  data() {
    return {
      chart: null as any
    };
  },
  mounted() {
    (this as any).createChart();
  },
  methods: {
    createChart() {
      const ctx = (this as any).$refs.barCanvas as HTMLCanvasElement;

      const isCustomerReport =
        (this as any).$route.name === 'CustomersSatisfactionReport';

      if (isCustomerReport) {
        const options: ChartOptions<'bar'> = {
          ...(this as any).optionsBarChart
        };

        options.plugins!.datalabels = {
          display: false
        };

        if ((this as any).id === 'barChartAmount') {
          options.plugins!.title!.text = (this as any).$t(
            'customersAmount'
          ) as string;
        } else {
          options.plugins!.title!.text = (this as any).$t(
            'customerFeedback'
          ) as string;
        }

        const myChart = new Chart(ctx, {
          type: 'bar',
          data: (this as any).dataBarChart,
          options
        });
      } else {
        const options: ChartOptions<'bar'> = {
          ...(this as any).optionsBarChart
        };

        options.plugins!.datalabels = {
          display: false
        };

        const myChart = new Chart(ctx, {
          type: 'bar',
          data: (this as any).dataBarChart,
          options
        });
      }
    }
  },
  beforeUnmount() {
    const self = this as any;
    if (self.chart) {
      self.chart.destroy();
    }
  },
  watch: {
    dataPieChart: {
      handler(
        this: ComponentPublicInstance & { createChart(): void; chart: any }
      ) {
        if (this.chart) {
          this.chart.destroy();
        }
        this.createChart();
      },
      deep: true
    }
  }
};
</script>
